import React from "react";
import { Routes, Route } from "react-router-dom";

import VH11Najdi from "./components/VH11Najdi";
import PogojiUporabe from "./components/PogojiUporabe";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<VH11Najdi />} />
      <Route path="/pogoji-uporabe" element={<PogojiUporabe />} />
      {/* opcijsko še politika */}
      {/* <Route path="/politika-zasebnosti" element={<PolitikaZasebnosti />} /> */}
    </Routes>
  );
}